export default __webpack_public_path__ + "static/media/multimedia_bar.648be37e.jpg";